// Auto-generated normalizer for table: Cat_Permisos
export function catPermisosNormalize(row) {
  return {
    idPermiso: row.idPermiso ?? row.IdPermiso ?? row['IdPermiso'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
